import { createContext } from 'preact';
import { AdParameters } from '../../types';

export const AdParametersContext = createContext<AdParameters<any>>({
  env: {
    asset_cdn_uri: process.env.asset_cdn_uri as any,
    asset_bucket_uri: process.env.asset_bucket_uri as any,
    studio_tag_uri: process.env.studio_tag_uri as any,
  },
  assetStatus: process.env.ASSET_STATUS as any,
  config: process.env.AD_CONFIG as any,
  assets: process.env.AD_ASSETS as any,
  creativeId: '',
});
